import { parseQueryParams } from "@faire/web--source/common/query-params/parseQueryParams";
import { useLocation } from "react-router-dom";
export var useIsNativeWebView = function() {
    var location = useLocation();
    var queryParams = parseQueryParams(location.search);
    return queryParams.get("native_env") === "true";
};
